import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Brand } from 'util/resources';
import { BrandResource } from 'util/resources/Brand';

export type BrandContextType = {
  brand: BrandResource;
};

export const BrandContext = createContext<BrandContextType>(null);

export const BrandContextProvider = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
  const [brand, setBrand] = useState<BrandResource>(null);

  useEffect(() => {
    Brand.findBy({ domain: window.location.hostname })
      .then((response) => {
        setBrand(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <BrandContext.Provider
      value={{
        brand,
      }}
    >
      {children}
    </BrandContext.Provider>
  );
};

// define useBrand hook
export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
};

type BrandAwareType = (brand: BrandResource) => any;
interface IBrandAwareProps {
  children: BrandAwareType;
}

export const BrandAware: FunctionComponent<IBrandAwareProps> = ({ children }) => {
  const { brand } = useBrand();

  return children(brand);
};
